export enum OfferRuleTypeEnumerator {
  OfferSetRule = 'offerSetRule',
  DollarDiscountRule = 'discountRule'
}
